export const toTitleCase = (text: string) => {
    if (!text) return '';

    return text.toLowerCase().split(' ').map(function(word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
};